import { render, staticRenderFns } from "./FormularioCtrlProcessoComponent.vue?vue&type=template&id=33eeaaea"
import script from "./FormularioCtrlProcessoComponent.vue?vue&type=script&lang=js"
export * from "./FormularioCtrlProcessoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports